import React from 'react';
import { Form } from 'react-bootstrap';
import Input from '../../components/Input/Input';
import Select from '../../components/Select/Select';
import Button from '../../components/Button/Button';
import './VisitorPass.css';

const VisitorForm = ({
  handleChange,
  handleSubmit,
  name,
  phone,
  meeting_with,
  purpose,
  category_id,
  captureImage,
  retakePhoto,
  videoRef,
  canvasRef,
  image,
  previewUrl,
  cameraState,
  startCamera,
  showPermissionHelp
}) => {
  const renderCameraSection = () => {
    if (cameraState.permission === 'denied' || cameraState.error) {
      return (
        <div className="permission-denied">
          <div className="permission-message">
            <h5>Camera Access Required</h5>
            <p>We need camera access to capture visitor photos.</p>
            {cameraState.error && <p className="error-message">{cameraState.error}</p>}
          </div>
          <div className="permission-actions">
            <Button variant="primary" onClick={startCamera}>
              Retry
            </Button>
            <Button variant="secondary" onClick={showPermissionHelp}>
              Help
            </Button>
          </div>
        </div>
      );
    }

    if (previewUrl) {
      return (
        <div className="preview-container">
          <img
            src={previewUrl}
            alt="Captured Visitor"
            className="captured-image"
          />
          <Button
            variant="danger"
            onClick={retakePhoto}
            className="retake-btn"
          >
            Retake Photo
          </Button>
        </div>
      );
    }

    return (
      <div className="camera-container">
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className="camera-feed"
        />
        <canvas
          ref={canvasRef}
          style={{ display: 'none' }}
          width="320"
          height="240"
        />
        <br/>
        <Button
          variant="primary"
          onClick={captureImage}
          disabled={!cameraState.ready}
          className="capture-btn mt-2"
        >
          {cameraState.ready ? 'Capture Photo' : 'Loading Camera...'}
        </Button>
      </div>
    );
  };

  return (
    <Form onSubmit={handleSubmit} className="visitor-form-container">
      <div className="form-camera-wrapper">
        {/* Form Section */}
        <div className="card-box form-section">
          <div className="card-title">Visitor Details</div>

          <Input
            label="Full Name"
            type="text"
            name="name"
            onChange={handleChange}
            placeholder="Enter visitor's full name"
            value={name}
            required
          />

          <Input
            label="Phone Number"
            type="tel"
            name="phone"
            onChange={handleChange}
            placeholder="Enter phone number"
            value={phone}
            required
          />

          <Input
            label="Visit Purpose"
            type="text"
            name="purpose"
            onChange={handleChange}
            placeholder="Reason for visit"
            value={purpose}
            required
          />

          <Input
            label="Meeting With"
            type="text"
            name="meeting_with"
            onChange={handleChange}
            placeholder="Person to meet"
            value={meeting_with}
            required
          />

          <Select
            label="Visitor Category"
            name="category_id"
            value={category_id}
            onChangeHandler={handleChange}
            options={[
              { id: 1, name: 'Parent' },
              { id: 2, name: 'Vendor' },
              { id: 3, name: 'Guest' }
            ]}
            placeholder="Select visitor category"
            required
          />

          <div className="submit-btn">
            <Button
              variant="primary"
              type="submit"
              disabled={!image}
              className="submit-btn"
            >
              {image ? 'Submit Visitor' : 'Please Capture Photo First'}
            </Button>
          </div>
        </div>

        {/* Camera Section */}
        <div className="card-box camera-section">
          <div className="card-title">Visitor Photo</div>
          {renderCameraSection()}
        </div>
      </div>
    </Form>
  );
};

export default VisitorForm;
